export const SOCIAL = 'social';
export const REGULAR = 'regular';
export const SSO = 'sso';
export const PAP = 'pap';
